import { UniversalNoPictureCard } from '@components/core-ui/UniversalNoPictureCard';
import styled from 'styled-components';

export const StyledUniversalNoPictureCard = styled(UniversalNoPictureCard)`
  height: auto;
  min-height: 72px;

  .card {
    position: relative;
    align-items: start;
    .actions {
      padding: 0;
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .card-text {
      width: 270px;
      color: var(--color-text);
      .font-medium {
        padding: 0 0 10px;
        color: var(--color-text);
      }
      .text-foreground-muted {
        color: var(--color-text-muted);
      }
      p {
        white-space: wrap;
        padding: 0 0 3px;
        color: var(--color-text-muted);
      }
      a,
      summary {
        color: var(--color-accent);
      }
      hr {
        border-color: var(--color-border);
      }
    }
  }
`;
